export default "__VITE_ASSET__oHW2ucJo__"